import React, { Component } from 'react';
import { computeDate } from '../../utils/tools';
import './appStyle.less';

class H5Pay extends Component {
    constructor(props){
        super(props);
        this.state = {
            channel:0,
            isAllow:true
        }
    }
    render(){
        console.log(this.props)
        return(
            <div className="container h5pay">
                {this.props.goodsInfo[this.props.id]? 
                    <div className="order">
                        <div className='lesson_detail'>
                            {/* <span className='num'>{this.props.goodsInfo[this.props.id].lessons}</span>
                            <span className='text'>课时</span>
                            <span className='price'>{this.props.goodsInfo[this.props.id].totalAmount/100}</span>
                            <span className='text'>元</span> */}
                            <span className="text">{this.props.goodsInfo[this.props.id].name}</span>
                            <div className="sub">
                                有效期{this.props.goodsInfo[this.props.id].expireDays}天
                            </div>
                        </div>
                        <div className="lesson_date">
                            <span>有效期至</span>
                            <span>{computeDate((this.props.lessonDate/1000),this.props.goodsInfo[this.props.id].expireDays)}</span>
                        </div>
                        <div className="lesson_price">
                            <span>应付金额</span>
                            <span className="price">{this.props.goodsInfo[this.props.id].totalAmount/100}元</span>
                        </div>
                    </div> : null
                }
                <div className="channel">
                    <div className="head">第三方支付</div>
                    <div className={`weixin pay ${this.state.channel===0?'active':''}`} onClick={()=>{this.setState({channel:0})}}>
                        <div className="img"></div>
                        <div className="name">微信支付</div>
                        <div className="btn"></div>
                    </div>
                    <div className={`alipay pay ${this.state.channel===1?'active':''}`} onClick={()=>{this.setState({channel:1})}}>
                        <div className="img"></div>
                        <div className="name">支付宝支付</div>
                        <div className="btn"></div>
                    </div>
                </div>
                <div className="rules">
                    <div className={`btn_wrap ${this.state.isAllow===true?'active':''}`} onClick={()=>{this.setState({isAllow:!this.state.isAllow})}}>
                        <div></div>
                    </div>
                    <a href="https://client.aircourses.com/pay/customerrules">同意AirCourse服务协议</a>
                </div>
                <div className="btn_submit" onClick={()=>{this.props.handleClick(this.state.isAllow,this.state.channel)}}>
                    立即支付
                </div>
                {/* {!window.location.href.indexOf("https") > -1 ?
                    <div className="pay_test"onClick={()=>{this.props.payTest(this.state.isAllow,this.state.channel)}} >测试</div> : null
                } */}
            </div>
        )
    }
}


export default H5Pay;



// WEBPACK FOOTER //
// ./src/template/Pay/H5Pay.jsx